import React, { useEffect, useRef, useState } from "react";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
// Icon
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import StorageIcon from "@mui/icons-material/Storage";
import FolderZipIcon from "@mui/icons-material/FolderZip";

import {
  Alert,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  LinearProgress,
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  startBackupUploads,
  startBackupDatabase,
  verifyImportBackup,
  startImportBackup,
  getJobStatus,
  listActiveJobs,
  cancelJob,
} from "../../../reduxToolkit/features/adminPanel/misc";
import {
  deleteAllNotification,
  getNotification,
} from "../../../reduxToolkit/features/adminPanel/notification";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  deleteAllRole,
  getRole,
} from "../../../reduxToolkit/features/adminPanel/role";
import {
  deleteAllAdmin,
  getAdmins,
} from "../../../reduxToolkit/features/adminPanel/admin";
import { axiosInstance, PF_backup } from "../../../config";
import CaptchaTikTakToe from "../../../components/misc/CaptchaTikTakToe";
import { updateAdminUrl } from "../../../reduxToolkit/features/adminPanel/adminUrl";
import { formatByteSize } from "../../../hooks/formatByteSize";
import CancelIcon from "@mui/icons-material/Cancel";

export default function AdvancedSettings({ translate2 }) {
  // AdminURl
  const [adminUrlLoading, setAdminUrlLoading] = useState(false);
  const [prevAdminUrlInfo, setPrevAdminUrlInfo] = useState("");
  const [adminUrl, setAdminUrl] = useState("");
  const [adminHint, setAdminHint] = useState("");
  const [adminUrlId, setAdminUrlId] = useState("");
  const [adminUrlChangesMade, setAdminUrlChangesMade] = useState(false);
  const [captchaDlg, setCaptchaDlg] = useState(false);

  // Back up (download) — each runs as a background job on the server, so
  // a big uploads folder doesn't block the whole site while it zips, and
  // a page refresh or dropped connection doesn't kill the job.
  const [dbBackupJob, setDbBackupJob] = useState(null);
  const [uploadsBackupJob, setUploadsBackupJob] = useState(null);
  const dbBackupPollRef = useRef(null);
  const uploadsBackupPollRef = useRef(null);

  // Import (upload -> verify -> confirm -> restore)
  const [importMenuAnchor, setImportMenuAnchor] = useState(null);
  const [importDlg, setImportDlg] = useState(false);
  const [importKind, setImportKind] = useState(""); // "database" | "uploads"
  const [importStage, setImportStage] = useState("idle"); // idle|uploading|verified|importing|done|error
  const [importProgress, setImportProgress] = useState(0);
  const [importToken, setImportToken] = useState("");
  const [importMessage, setImportMessage] = useState("");
  const [importConfirmText, setImportConfirmText] = useState("");
  const [importJob, setImportJob] = useState(null);
  const importPollRef = useRef(null);
  const importDatabaseInputRef = useRef(null);
  const importUploadsInputRef = useRef(null);
  // notification
  const [dltNotiDlg, setDltNotiDlg] = useState(false);
  const [dltNotiLoading, setDltNotiLoading] = useState(false);
  // Admin
  const [dltAdminDlg, setDltAdminDlg] = useState(false);
  const [dltAdminLoading, setDltAdminLoading] = useState(false);
  // role
  const [dltRoleDlg, setDltRoleDlg] = useState(false);
  const [dltRoleLoading, setDltRoleLoading] = useState(false);
  // Use Effect
  useEffect(() => {
    getAdminUrl();
  }, []);

  const getAdminUrl = async () => {
    const res = await axiosInstance.get("/api/adminUrl");
    setPrevAdminUrlInfo(res.data);
    setAdminUrl(res.data.url);
    setAdminHint(res.data.hint);
    setAdminUrlId(res.data._id);
  };

  // Check If admin url changed
  useEffect(() => {
    if (
      adminUrl !== prevAdminUrlInfo.url ||
      adminHint !== prevAdminUrlInfo.hint
    )
      setAdminUrlChangesMade(true);
    else setAdminUrlChangesMade(false);
  }, [adminHint, adminUrl, prevAdminUrlInfo.hint, prevAdminUrlInfo.url]);

  //   localdata
  const localData = JSON.parse(localStorage.getItem("adminLoginInfo"));

  //   Functions
  const dispatch = useDispatch();

  // Admin Url Change
  const handleAdminUrlChange = () => {
    setCaptchaDlg(true);
  };

  const changeAdminUrl = () => {
    setAdminUrlLoading(true);
    dispatch(
      updateAdminUrl({
        url: adminUrl,
        hint: adminHint,
        id: adminUrlId,
        creatorId: localData._id,
      })
    );
    setTimeout(() => {
      setAdminUrlLoading(false);
      window.location.replace(`/${adminUrl}`);
    }, 2000);
  };

  // Delete All Notification
  const handleDeleteAllNotification = () => {
    setDltNotiLoading(true);
    dispatch(deleteAllNotification());
    setTimeout(() => {
      dispatch(getNotification());
      setDltNotiDlg(false);
      setDltNotiLoading(false);
    }, 2000);
  };

  // Delete All Admins
  const handleDeleteAllAdmins = () => {
    setDltAdminLoading(true);
    dispatch(deleteAllAdmin({ adminTryingId: localData._id }));
    setTimeout(() => {
      dispatch(getNotification());
      dispatch(getRole());
      dispatch(getAdmins());
      setDltAdminDlg(false);
      setDltAdminLoading(false);
    }, 2000);
  };

  // Delete All Roles
  const handleDeleteAllRoles = () => {
    setDltRoleLoading(true);
    dispatch(deleteAllRole({ adminTryingId: localData._id }));
    setTimeout(() => {
      dispatch(getNotification());
      dispatch(getRole());
      dispatch(getAdmins());
      setDltRoleDlg(false);
      setDltRoleLoading(false);
    }, 2000);
  };

  // Triggers a browser download of an already-served static file
  const triggerDownload = (fileName) => {
    const a = document.createElement("a");
    a.href = `${PF_backup}${fileName}`;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // Polls a background job's status every second until it stops running.
  // Backups/imports run server-side independent of this request, so a
  // page refresh just means we lose the interval — reattachment on mount
  // (below) picks it back up.
  const pollJob = (jobId, setJobState, intervalRef, onSettled) => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(async () => {
      try {
        const res = await dispatch(getJobStatus(jobId)).unwrap();
        setJobState(res);
        if (res.status !== "running") {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          if (onSettled) onSettled(res);
        }
      } catch (err) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }, 1000);
  };

  const handleBackupDatabase = async () => {
    try {
      const res = await dispatch(startBackupDatabase()).unwrap();
      setDbBackupJob({
        id: res.jobId,
        status: "running",
        stage: "dumping",
        processedBytes: 0,
        totalBytes: 0,
      });
      pollJob(res.jobId, setDbBackupJob, dbBackupPollRef, (job) => {
        if (job.status === "done" && job.fileName) triggerDownload(job.fileName);
      });
    } catch (err) {
      // handled via job status/error display
    }
  };

  const handleBackupUploads = async () => {
    try {
      const res = await dispatch(startBackupUploads()).unwrap();
      setUploadsBackupJob({
        id: res.jobId,
        status: "running",
        stage: "compressing",
        processedBytes: 0,
        totalBytes: 0,
      });
      pollJob(res.jobId, setUploadsBackupJob, uploadsBackupPollRef, (job) => {
        if (job.status === "done" && job.fileName) triggerDownload(job.fileName);
      });
    } catch (err) {
      // handled via job status/error display
    }
  };

  const handleCancelDbBackup = () => {
    if (dbBackupJob) dispatch(cancelJob(dbBackupJob.id));
  };
  const handleCancelUploadsBackup = () => {
    if (uploadsBackupJob) dispatch(cancelJob(uploadsBackupJob.id));
  };

  // Reattach to any backup/import jobs already running server-side —
  // covers the case where the admin refreshed the page (or reconnected
  // after a dropped connection) while one was in progress.
  useEffect(() => {
    (async () => {
      try {
        const [dbJob] = await dispatch(listActiveJobs("backup-database")).unwrap();
        if (dbJob) {
          setDbBackupJob(dbJob);
          pollJob(dbJob.id, setDbBackupJob, dbBackupPollRef, (job) => {
            if (job.status === "done" && job.fileName) triggerDownload(job.fileName);
          });
        }
      } catch (err) {
        // ignore
      }
      try {
        const [uploadsJob] = await dispatch(listActiveJobs("backup-uploads")).unwrap();
        if (uploadsJob) {
          setUploadsBackupJob(uploadsJob);
          pollJob(uploadsJob.id, setUploadsBackupJob, uploadsBackupPollRef, (job) => {
            if (job.status === "done" && job.fileName) triggerDownload(job.fileName);
          });
        }
      } catch (err) {
        // ignore
      }
      try {
        const [dbImportJobs, uploadsImportJobs] = await Promise.all([
          dispatch(listActiveJobs("import-database")).unwrap(),
          dispatch(listActiveJobs("import-uploads")).unwrap(),
        ]);
        const activeImportJob = [...dbImportJobs, ...uploadsImportJobs][0];
        if (activeImportJob) {
          setImportKind(activeImportJob.kind === "import-database" ? "database" : "uploads");
          setImportDlg(true);
          setImportStage("importing");
          setImportJob(activeImportJob);
          pollJob(activeImportJob.id, setImportJob, importPollRef, (job) => {
            if (job.status === "done") {
              setImportStage("done");
              setImportMessage(job.message);
              dispatch(getNotification());
            } else {
              setImportStage("error");
              setImportMessage(
                job.status === "cancelled" ? "Import cancelled" : job.message
              );
            }
          });
        }
      } catch (err) {
        // ignore
      }
    })();
    return () => {
      if (dbBackupPollRef.current) clearInterval(dbBackupPollRef.current);
      if (uploadsBackupPollRef.current) clearInterval(uploadsBackupPollRef.current);
      if (importPollRef.current) clearInterval(importPollRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Import flow — step 1: pick a file for a given kind, upload it, and
  // have the backend verify it's structurally valid before anything live
  // is touched.
  const handleImportMenuSelect = (kind) => {
    setImportMenuAnchor(null);
    setImportKind(kind);
    const ref = kind === "database" ? importDatabaseInputRef : importUploadsInputRef;
    if (ref.current) {
      ref.current.value = "";
      ref.current.click();
    }
  };

  const handleImportFileSelected = async (e, kind) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;

    setImportKind(kind);
    setImportDlg(true);
    setImportStage("uploading");
    setImportProgress(0);
    setImportToken("");
    setImportMessage("");
    setImportConfirmText("");
    setImportJob(null);

    const data = new FormData();
    data.append("file", file);
    data.append("kind", kind);

    try {
      const res = await dispatch(
        verifyImportBackup({
          data,
          onUploadProgress: (evt) => {
            if (evt.total) {
              setImportProgress(Math.round((evt.loaded / evt.total) * 100));
            }
          },
        })
      ).unwrap();

      if (res.valid) {
        setImportStage("verified");
        setImportToken(res.token);
      } else {
        setImportStage("error");
        setImportMessage(res.message || "This file failed verification.");
      }
    } catch (err) {
      setImportStage("error");
      setImportMessage(
        err.message === "Network Error"
          ? "Upload interrupted — check your connection and try again."
          : err.message || "Upload failed."
      );
    }
  };

  const handleConfirmImport = async () => {
    if (importConfirmText !== "IMPORT") return;
    setImportStage("importing");
    try {
      const res = await dispatch(
        startImportBackup({ kind: importKind, token: importToken })
      ).unwrap();
      if (res.failed) {
        setImportStage("error");
        setImportMessage(res.message);
        return;
      }
      setImportJob({
        id: res.jobId,
        status: "running",
        stage: "extracting",
        processedBytes: 0,
        totalBytes: 0,
      });
      pollJob(res.jobId, setImportJob, importPollRef, (job) => {
        if (job.status === "done") {
          setImportStage("done");
          setImportMessage(job.message);
          dispatch(getNotification());
        } else {
          setImportStage("error");
          setImportMessage(
            job.status === "cancelled" ? "Import cancelled" : job.message
          );
        }
      });
    } catch (err) {
      setImportStage("error");
      setImportMessage(err.message || "Import failed.");
    }
  };

  const handleCancelImport = () => {
    if (importJob) dispatch(cancelJob(importJob.id));
  };

  const handleCloseImportDlg = () => {
    setImportDlg(false);
    setImportStage("idle");
    setImportProgress(0);
    setImportToken("");
    setImportMessage("");
    setImportConfirmText("");
    setImportKind("");
    setImportJob(null);
  };

  //! Translate
  // Store
  const { langArrFromClientSide } = useSelector((state) => state.misc);
  const translate0 = (String) => {
    let translation = "";
    if (langArrFromClientSide && langArrFromClientSide.length > 0) {
      const T = langArrFromClientSide.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      } else if (T === undefined) translation = String;
    }
    return translation;
  };
  //! Translate
  return (
    <>
      <Grid container spacing={1} justifyContent="space-around">
            <Grid
              item
              xs={12}
              sm={4}
              sx={{
                border: ".2rem Solid lightblue",
                p: 1,
                borderRadius: ".25rem",
              }}
            >
              <Typography
                variant="subtitle2"
                color="primary"
                align="center"
                sx={{ borderBottom: ".2rem solid lightblue" }}
              >
                {translate2("Change Admin Url")}
              </Typography>
              <TextField
                label={translate2("Admin Url")}
                required
                value={adminUrl}
                onChange={(e) => setAdminUrl(e.target.value)}
                variant="standard"
                fullWidth
              />
              <TextField
                label={translate2("Hint")}
                value={adminHint}
                onChange={(e) => setAdminHint(e.target.value)}
                variant="standard"
                fullWidth
                sx={{ mb: 1 }}
              />
              <LoadingButton
                loading={adminUrlLoading}
                loadingPosition="end"
                endIcon={<ChangeCircleIcon />}
                variant="contained"
                size="small"
                fullWidth
                onClick={handleAdminUrlChange}
                disabled={!adminUrlChangesMade}
              >
                {translate2("Change")}
              </LoadingButton>
              <Dialog
                open={captchaDlg}
                onClose={() => setCaptchaDlg(false)}
                aria-labelledby={"change-admin-url"}
              >
                <DialogContent>
                  <CaptchaTikTakToe
                    setCaptchaDlg={setCaptchaDlg}
                    loginFunc={changeAdminUrl}
                  />
                </DialogContent>
              </Dialog>
            </Grid>
            {/* Backup */}
            <Grid item xs={12} sm={4}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <LoadingButton
                    variant="contained"
                    size="small"
                    fullWidth
                    sx={{ height: "50px" }}
                    color="secondary"
                    startIcon={<StorageIcon />}
                    onClick={handleBackupDatabase}
                    loading={dbBackupJob && dbBackupJob.status === "running"}
                  >
                    {translate0("Download Database Backup")}
                  </LoadingButton>
                  {dbBackupJob && dbBackupJob.status === "running" && (
                    <Box sx={{ mt: 0.5 }}>
                      <LinearProgress
                        color="secondary"
                        variant={dbBackupJob.totalBytes ? "determinate" : "indeterminate"}
                        value={
                          dbBackupJob.totalBytes
                            ? Math.round(
                                (dbBackupJob.processedBytes / dbBackupJob.totalBytes) * 100
                              )
                            : 0
                        }
                      />
                      <Grid container justifyContent="space-between" alignItems="center">
                        <Typography variant="caption" color="text.secondary">
                          {dbBackupJob.stage === "dumping"
                            ? translate0("Dumping database")
                            : translate0("Compressing")}
                          {dbBackupJob.totalBytes
                            ? ` — ${formatByteSize(dbBackupJob.processedBytes)} / ${formatByteSize(
                                dbBackupJob.totalBytes
                              )}`
                            : "..."}
                        </Typography>
                        <Button
                          size="small"
                          color="error"
                          startIcon={<CancelIcon fontSize="small" />}
                          onClick={handleCancelDbBackup}
                        >
                          {translate0("Cancel")}
                        </Button>
                      </Grid>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <LoadingButton
                    variant="contained"
                    size="small"
                    fullWidth
                    sx={{ height: "50px" }}
                    color="info"
                    startIcon={<FolderZipIcon />}
                    onClick={handleBackupUploads}
                    loading={uploadsBackupJob && uploadsBackupJob.status === "running"}
                  >
                    {translate0("Download Uploads Backup")}
                  </LoadingButton>
                  {uploadsBackupJob && uploadsBackupJob.status === "running" && (
                    <Box sx={{ mt: 0.5 }}>
                      <LinearProgress
                        color="info"
                        variant={uploadsBackupJob.totalBytes ? "determinate" : "indeterminate"}
                        value={
                          uploadsBackupJob.totalBytes
                            ? Math.round(
                                (uploadsBackupJob.processedBytes / uploadsBackupJob.totalBytes) *
                                  100
                              )
                            : 0
                        }
                      />
                      <Grid container justifyContent="space-between" alignItems="center">
                        <Typography variant="caption" color="text.secondary">
                          {translate0("Zipping uploads folder")}
                          {uploadsBackupJob.totalBytes
                            ? ` — ${formatByteSize(
                                uploadsBackupJob.processedBytes
                              )} / ${formatByteSize(uploadsBackupJob.totalBytes)}`
                            : "..."}
                        </Typography>
                        <Button
                          size="small"
                          color="error"
                          startIcon={<CancelIcon fontSize="small" />}
                          onClick={handleCancelUploadsBackup}
                        >
                          {translate0("Cancel")}
                        </Button>
                      </Grid>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    color="warning"
                    endIcon={<ArrowDropDownIcon />}
                    onClick={(e) => setImportMenuAnchor(e.currentTarget)}
                  >
                    {translate0("Import")}
                  </Button>
                  <Menu
                    anchorEl={importMenuAnchor}
                    open={Boolean(importMenuAnchor)}
                    onClose={() => setImportMenuAnchor(null)}
                  >
                    <MenuItem onClick={() => handleImportMenuSelect("database")}>
                      <ListItemIcon>
                        <StorageIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>{translate0("Import Database")}</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={() => handleImportMenuSelect("uploads")}>
                      <ListItemIcon>
                        <FolderZipIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>{translate0("Import Uploads")}</ListItemText>
                    </MenuItem>
                  </Menu>
                  <input
                    type="file"
                    accept=".zip"
                    hidden
                    ref={importDatabaseInputRef}
                    onChange={(e) => handleImportFileSelected(e, "database")}
                  />
                  <input
                    type="file"
                    accept=".zip"
                    hidden
                    ref={importUploadsInputRef}
                    onChange={(e) => handleImportFileSelected(e, "uploads")}
                  />
                </Grid>
              </Grid>

              {/* Import progress / confirm dialog */}
              {importDlg && (
                <Dialog
                  open={importDlg}
                  onClose={
                    importStage === "uploading" || importStage === "importing"
                      ? undefined
                      : handleCloseImportDlg
                  }
                  fullWidth
                  maxWidth="xs"
                >
                  <DialogTitle>
                    {importKind === "database"
                      ? translate0("Import Database")
                      : translate0("Import Uploads")}
                  </DialogTitle>
                  <DialogContent>
                    {importStage === "uploading" && (
                      <Box sx={{ mt: 1, mb: 1 }}>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          {translate0("Uploading & verifying")}... {importProgress}%
                        </Typography>
                        <LinearProgress
                          variant="determinate"
                          value={importProgress}
                        />
                      </Box>
                    )}

                    {importStage === "verified" && (
                      <>
                        <Alert severity="success" sx={{ mb: 2 }}>
                          {translate0("Backup file verified successfully")}.
                        </Alert>
                        <Alert severity="warning" sx={{ mb: 2 }}>
                          {importKind === "database"
                            ? translate0(
                                "This will replace the entire current database"
                              )
                            : translate0(
                                "This will replace files currently in the uploads folder"
                              )}
                          . {translate0("This cannot be undone")}.
                        </Alert>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          {translate0("Type")} <b>IMPORT</b>{" "}
                          {translate0("below to confirm")}.
                        </Typography>
                        <TextField
                          value={importConfirmText}
                          onChange={(e) => setImportConfirmText(e.target.value)}
                          fullWidth
                          size="small"
                          variant="standard"
                          placeholder="IMPORT"
                        />
                      </>
                    )}

                    {importStage === "importing" && (
                      <Box sx={{ mt: 1, mb: 1 }}>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          {importJob && importJob.stage === "restoring"
                            ? translate0("Restoring database")
                            : translate0("Extracting")}
                          {importJob && importJob.totalBytes
                            ? ` — ${formatByteSize(importJob.processedBytes)} / ${formatByteSize(
                                importJob.totalBytes
                              )}`
                            : "..."}
                        </Typography>
                        <LinearProgress
                          variant={
                            importJob && importJob.totalBytes ? "determinate" : "indeterminate"
                          }
                          value={
                            importJob && importJob.totalBytes
                              ? Math.round(
                                  (importJob.processedBytes / importJob.totalBytes) * 100
                                )
                              : 0
                          }
                        />
                      </Box>
                    )}

                    {importStage === "done" && (
                      <Alert severity="success">
                        {importMessage || translate0("Imported successfully")}
                      </Alert>
                    )}

                    {importStage === "error" && (
                      <Alert severity="error">{importMessage}</Alert>
                    )}
                  </DialogContent>
                  <DialogActions>
                    {importStage === "importing" && (
                      <Button
                        onClick={handleCancelImport}
                        color="error"
                        startIcon={<CancelIcon fontSize="small" />}
                      >
                        {translate0("Cancel")}
                      </Button>
                    )}
                    {(importStage === "verified" ||
                      importStage === "done" ||
                      importStage === "error") && (
                      <Button onClick={handleCloseImportDlg} color="primary">
                        {translate0(
                          importStage === "verified" ? "Cancel" : "Close"
                        )}
                      </Button>
                    )}
                    {importStage === "verified" && (
                      <LoadingButton
                        onClick={handleConfirmImport}
                        disabled={importConfirmText !== "IMPORT"}
                        color="warning"
                        variant="contained"
                      >
                        {translate0("Confirm")}
                      </LoadingButton>
                    )}
                  </DialogActions>
                </Dialog>
              )}
            </Grid>
            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                size="small"
                color="error"
                fullWidth
                onClick={() => setDltNotiDlg(true)}
                sx={{ mb: 1 }}
              >
                {translate2("Delete All Notification")}
              </Button>
              {/* delete notification Dialog */}
              <Dialog
                open={dltNotiDlg}
                onClose={() => setDltNotiDlg(false)}
                aria-labelledby={"delete-all-notification"}
              >
                <DialogTitle>
                  {translate2("Do You Want To Delete All Notification?")}
                </DialogTitle>
                <DialogActions>
                  <Button onClick={() => setDltNotiDlg(false)} color="primary">
                    {translate2("Cancel")}
                  </Button>
                  <LoadingButton
                    endIcon={<DeleteOutlineIcon sx={{ mb: 0.5 }} />}
                    loading={dltNotiLoading}
                    loadingPosition="end"
                    onClick={handleDeleteAllNotification}
                    color="error"
                  >
                    {translate2("Confirm")}
                  </LoadingButton>
                </DialogActions>
              </Dialog>

              <Button
                variant="contained"
                size="small"
                color="error"
                fullWidth
                onClick={() => setDltAdminDlg(true)}
                sx={{ mb: 1 }}
              >
                {translate2("Delete All Admins")}
              </Button>
              {/* Delete All Admins Dialog */}
              <Dialog
                open={dltAdminDlg}
                onClose={() => setDltAdminDlg(false)}
                aria-labelledby={"delete-all-notification"}
              >
                <DialogTitle>
                  {translate2("Do You Want To Delete All Admins?")}
                </DialogTitle>
                <DialogActions>
                  <Button onClick={() => setDltAdminDlg(false)} color="primary">
                    {translate2("Cancel")}
                  </Button>
                  <LoadingButton
                    endIcon={<DeleteOutlineIcon sx={{ mb: 0.5 }} />}
                    loading={dltAdminLoading}
                    loadingPosition="end"
                    onClick={handleDeleteAllAdmins}
                    color="error"
                  >
                    {translate2("Confirm")}
                  </LoadingButton>
                </DialogActions>
              </Dialog>

              <Button
                variant="contained"
                size="small"
                color="error"
                fullWidth
                onClick={() => setDltRoleDlg(true)}
                sx={{ mb: 1 }}
              >
                {translate2("Delete All Roles")}
              </Button>
              {/* Delete All Roles Dialog */}
              <Dialog
                open={dltRoleDlg}
                onClose={() => setDltRoleDlg(false)}
                aria-labelledby={"delete-all-notification"}
              >
                <DialogTitle>
                  {translate2("Do You Want To Delete All Roles?")}
                </DialogTitle>
                <DialogActions>
                  <Button onClick={() => setDltRoleDlg(false)} color="primary">
                    {translate2("Cancel")}
                  </Button>
                  <LoadingButton
                    endIcon={<DeleteOutlineIcon sx={{ mb: 0.5 }} />}
                    loading={dltRoleLoading}
                    loadingPosition="end"
                    onClick={handleDeleteAllRoles}
                    color="error"
                  >
                    {translate2("Confirm")}
                  </LoadingButton>
                </DialogActions>
              </Dialog>
            </Grid>
          </Grid>

    </>
  );
}
